import { createContext } from "react";

const expenseContext = createContext();

export default expenseContext;